import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, saveAuth } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { CohnectLogo } from "@/components/site/CohnectLogo";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      saveAuth(r.data.access_token, r.data.profile);
      toast.success("Welcome back");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error("Sign in failed", { description: err?.response?.data?.detail || "Invalid credentials" });
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[color:var(--coh-paper)] hero-wash flex items-center justify-center px-4">
      <Card className="w-full max-w-md p-8 rounded-xl bg-card shadow-soft">
        <CohnectLogo iconSize={22} />
        <div className="kicker mt-6">Admin</div>
        <h1 className="mt-1 font-display text-3xl font-bold">Sign in</h1>
        <form className="mt-6 space-y-4" onSubmit={submit} data-testid="admin-login-form">
          <div>
            <label className="text-sm font-medium">Email</label>
            <Input required type="email" data-testid="admin-login-email-input" value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-1 h-11" autoComplete="email" />
          </div>
          <div>
            <label className="text-sm font-medium">Password</label>
            <div className="relative mt-1">
              <Input required type={show ? "text" : "password"} data-testid="admin-login-password-input" value={password} onChange={(e)=>setPassword(e.target.value)} className="h-11 pr-10" autoComplete="current-password" />
              <button type="button" aria-label="Toggle password visibility" onClick={() => setShow(v => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground">
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="w-full h-11 bg-[color:var(--coh-blue)] text-white hover:bg-[color:var(--coh-blue)]/90 rounded-full font-semibold shadow-[0_10px_24px_-8px_rgba(0,116,255,0.55)]">
            {loading ? "Signing in\u2026" : "Sign in"}
          </Button>
        </form>
        <p className="mt-6 text-xs text-muted-foreground">Admin access only. Contact the owner if you need credentials.</p>
      </Card>
    </div>
  );
}
